export default __webpack_public_path__ + "static/media/flag-usa.f68d5585.svg";